import type { CodeCellLanguage } from '@/app/quadratic-core-types';
import type { CodeCell } from '@/app/shared/types/codeCell';

export interface ChangeInputOptions {
  readOnly?: boolean;
  tableCodeCell?: CodeCell;
}

export function isCodeTableLanguage(language: CodeCellLanguage): boolean {
  return language !== 'Formula' && language !== 'Import';
}
